// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2UG0t","containerItemsCenter":"Skeleton_containerItemsCenter__3Ndhf"};